import { useMemo } from 'react'
import type { FactoryHookType } from '../type'
import maybeCreatePhaseTypeFilterNode from './PhaseTypeFilterNodeFactory'

const usePhaseTypeFilterNode: FactoryHookType = ({ RendererComponent, options }) => {
  return useMemo(() => {
    return maybeCreatePhaseTypeFilterNode({
      componentType: options.componentType,
      RendererComponent,
    })
  }, [options.componentType, RendererComponent])
}

export default usePhaseTypeFilterNode
